import { FC } from "react";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { useAddClientAction } from "./useAddClientAction";

export const AddClientTrigger: FC = () => {
    const addClientAction = useAddClientAction();

    if (!addClientAction.isEnrollmentRequired) {
        return (
            <WithHotkey
                hotKey="alt+n"
                hotKeyOptions={{
                    description: "Add Client",
                    preventDefault: true,
                    enableOnFormTags: true,
                }}
            >
                <Button
                    variant="primary"
                    size="md"
                    onClick={addClientAction.addClient}
                >
                    Add Client
                </Button>
            </WithHotkey>
        );
    } else {
        return (
            <Tooltip content={addClientAction.disabledReason}>
                <Button
                    variant="primary"
                    size="md"
                    onClick={addClientAction.addClient}
                    disabled={addClientAction.isDisabled}
                >
                    Add Client
                </Button>
            </Tooltip>
        );
    }
};
